<div class="no-access-container">
    <div class="no-access-block">
        <div class="no-access-title">While your disguise is really cute...</div>
        <div class="no-access-text">
            You didn't fool me. You need an account created by the onboarding
            team to be let in to CMC Journey. Reach out to them to get an
            account.
        </div>
    </div>
</div>
